import axios from "config/axios";
import { GenericListResponse, GenericPageResponse, GenericResponse } from "shared/common";
import { BaseCurrency, CompanySite, Item, Order, Tool, Warehouse } from "shared/types";
import { CashRegister } from "./cash-register.api";

export type Receipt = {
  cashRegister: CashRegister | null;
  companySite: CompanySite | null;
  currency: BaseCurrency;
  grossPriceA: number;
  grossPriceB: number;
  grossPriceC: number;
  grossPriceE: number;
  id: number;
  netPriceA: number;
  netPriceB: number;
  netPriceC: number;
  netPriceE: number;
  releaseDate: string;
  tenantId: number;
  vatPercentageA: number;
  vatPercentageB: number;
  vatPercentageC: number;
  vatPercentageE: number;
  vatPriceA: number;
  vatPriceB: number;
  vatPriceC: number;
  vatPriceE: number;
};

const ENDPOINT = "/receipt-summary";

export const createReceipt = (param: Partial<Receipt>, tenantId: number) => {
  return axios.post<GenericPageResponse<any>>(`${ENDPOINT}`, { param, tenantId });
};

export const uploadCsvReceipt = (file: File, tenantId: number) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("tenantId", tenantId.toString());

  return axios.post<GenericPageResponse<any>>(`${ENDPOINT}/import-from-csv`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const listReceiptPageable = (
  page: number,
  size: number,
  tenantId: number,
  search: string = "",
  sort: string = "",
) =>
  axios.get<GenericPageResponse<Receipt>>(
    `${ENDPOINT}/all?page=${page}&size=${size}&tenantId=${tenantId}&search=${search}&sort=${sort}`,
  );
